<script>
    export default {
        name: 'modalMessageAddFavorites',
        render() { 
            return null
        },
        props: ['dontShow', 'icon'],
        methods: {
            dontShowMessageFavorites() {
                this.axios.post(API_URL + '/cookies/nao-mostrar-mensagem-favoritos', { 'accept_cookies' : 1 })
            },
            showMessageFavorites() {     
                
                if (this.dontShow == 1) {
                    return false
                }
            
                this.$fire({
                    text: "Adicione o site do Meus Pedidos Atlas nos favoritos no seu navegador. É mais facilidade para o acesso!",
                    type: "alert",
                    confirmButtonText: "Fechar",
                    allowOutsideClick: false,
                    imageUrl: this.icon,
                    imageWidth: 110,
                    imageHeight: 110,
                    icon: undefined,
                }).then(result => {
                    this.dontShowMessageFavorites()
                });
            }
        },
        mounted()
        {
            this.showMessageFavorites()         
        }
    }
</script>